import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IMenuItem {
  id?: string;
  navbar_id?: number;  // This is nav_bar.id
  parent_id?: string | null;
  title: string;
  slug: string;
  url?: string;
  status: boolean;  // Changed from is_active
  priority: number; // Changed from order_index
  icon?: string;
  text_color?: string;      // Added
  is_button?: boolean;      // Added
  button_color?: string;    // Added (background)
  button_border_color?: string;
  button_font_size?: string;
  is_cta?: boolean;
  children?: IMenuItem[];
}

export async function createMenuItem(payload: Partial<IMenuItem>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.MENU_ITEM.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateMenuItem(id: number, payload: Partial<IMenuItem>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.MENU_ITEM.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function getAllMenuItems() {
  try {
    const response = await adminAxios.get(
      ADMIN_API_ENDPOINTS.MENU_ITEM.GET_ALL
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function deleteMenuItem(id: number) {
  try {
    const response = await adminAxios.delete(
      ADMIN_API_ENDPOINTS.MENU_ITEM.DELETE(id)
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function getMenuItemsByNavbarId(navbarId: number) {
  try {
    const response = await adminAxios.get(
      ADMIN_API_ENDPOINTS.MENU_ITEM.GET_BY_NAVBAR_ID(navbarId)
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
